import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { BookIcon, BookOpenIcon, GraduationCapIcon, BookmarkIcon, StarIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Sidebar() {
  const {
    isArabic
  } = useLanguage();
  const categories = [{
    id: 'all',
    name: {
      en: 'All Videos',
      ar: 'جميع الفيديوهات'
    },
    icon: BookOpenIcon,
    count: 24
  }, {
    id: 'phrases',
    name: {
      en: 'Common Phrases',
      ar: 'العبارات الشائعة'
    },
    icon: BookmarkIcon,
    count: 8
  }, {
    id: 'business',
    name: {
      en: 'Business English',
      ar: 'الإنجليزية للأعمال'
    },
    icon: GraduationCapIcon,
    count: 6
  }, {
    id: 'conversation',
    name: {
      en: 'Conversation',
      ar: 'المحادثة'
    },
    icon: BookIcon,
    count: 5
  }, {
    id: 'grammar',
    name: {
      en: 'Grammar',
      ar: 'القواعد'
    },
    icon: BookIcon,
    count: 5
  }];
  return <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-5" data-id="element-1357">
      <h3 className="font-medium text-gray-900 dark:text-white mb-4" data-id="element-1358">
        {isArabic ? 'الفئات' : 'Categories'}
      </h3>
      <nav className="space-y-1" data-id="element-1359">
        {categories.map(category => <Link key={category.id} to={`/learn/video-lessons?category=${category.id}`} className="flex items-center justify-between py-2 px-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors" data-id="element-1360">
            <div className="flex items-center gap-3" data-id="element-1361">
              <category.icon className="w-4 h-4 text-gray-500 dark:text-gray-400" data-id="element-1362" />
              <span className="text-gray-700 dark:text-gray-300" data-id="element-1363">
                {isArabic ? category.name.ar : category.name.en}
              </span>
            </div>
            <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1364">
              {category.count}
            </span>
          </Link>)}
      </nav>
      <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-700" data-id="element-1365">
        <h3 className="font-medium text-gray-900 dark:text-white mb-4" data-id="element-1366">
          {isArabic ? 'فيديوهات مميزة' : 'Featured Videos'}
        </h3>
        <div className="space-y-3" data-id="element-1367">
          {[1, 2].map(item => <Link key={item} to={`/learn/video-lessons/${item}`} className="flex items-start gap-2 group" data-id="element-1368">
              <div className="w-16 h-12 bg-gray-200 dark:bg-gray-700 rounded overflow-hidden flex-shrink-0" data-id="element-1369">
                <img src={`https://images.unsplash.com/photo-149975013${item}0107-5fef28a66643?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80`} alt="" className="w-full h-full object-cover" data-id="element-1370" />
              </div>
              <div data-id="element-1371">
                <h4 className="text-sm text-gray-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors" data-id="element-1372">
                  {isArabic ? 'فيديو تعليمي مميز' : 'Featured Educational Video'}
                </h4>
                <div className="flex items-center gap-1 mt-1" data-id="element-1373">
                  <StarIcon className="w-3 h-3 text-yellow-500" data-id="element-1374" />
                  <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1375">
                    4.8
                  </span>
                </div>
              </div>
            </Link>)}
        </div>
      </div>
    </div>;
}